/**
 * @file agent constants
 * @author malcolmmzma
 */

import { map } from 'lodash';

import { RecommendPrompt } from '../components/recommend-prompt-list';

// 默认看板生成提示词
export const DEFAULT_RECOMMEND_PROMPTS: RecommendPrompt[] = [
  {
    id: 'daily-account-performance',
    title: '账户效果看板',
    description: '近 7 天各个账户花费、展示、点击、目标转化、ROI 等数据对比',
  },
  {
    id: 'daily-product-insight',
    title: '推广产品看板',
    description: '近 7 天各个推广产品的花费、转化量、转化成本、ROI 等数据对比',
  },
  {
    id: 'daily-creative-analysis',
    title: '广告创意看板',
    description: '近 7 天各个广告创意的花费、展示、点击、目标转化的数据对比',
  },
  {
    id: 'daily-placement-analysis',
    title: '版位效果看板',
    description: '近 7 天分版位效果看板，包括各版位花费、曝光、点击、转化、转化成本等数据',
  },
  {
    id: 'daily-audience-analysis',
    title: '人群效果看板',
    description: '近 7 天不同年龄段、性别人群的广告效果数据看板',
  },
  {
    id: 'daily-ad-analysis',
    title: '今日广告效果看板',
    description: '今日分时广告效果数据看板，包含广告花费、曝光、点击、转化、播放等数据',
  },
];

// 默认查数提示词
export const DEFAULT_QUERY_PROMPTS = [
  '今日花费最高的 10 个账户？',
  '近 7 天花费 >100 的 Top 10 浅层转化率账户？',
  '昨天曝光量 >1000 且 点击率最高的 5 个创意？',
];

export const DEFAULT_PROMPT = '帮我生成每日账户/广告/创意/推广产品等数据监控看板（支持近 2 周数据）';

export const AGENT_SOURCE_LIST = [
  // 看板
  {
    name: '数据看板',
    id: 553,
  },
  // {
  //   name: '稳定版',
  //   id: 21,
  //   description: '最标准最稳定，经过多轮测评脱颖而出',
  // },
  // {
  //   name: '灵活版',
  //   id: 23,
  //   description: '最多样最快，各种特殊的样式都有',
  // },
  // {
  //   name: 'Agent_5',
  //   id: 24,
  //   description: '测试 Agent 5',
  // },
];

export const AGENT_MAP: Record<string, any> = AGENT_SOURCE_LIST.reduce((acc, agent) => {
  acc[agent.id] = {
    ...agent,
    openApiConfig: {
      type: 'agent_management' as const,
      url: '/sso_cgi/eden/chatStream',
      params: {
        agent_id: agent.id,
      },
    },
  };
  return acc;
}, {});

export const AGENT_LIST = map(AGENT_MAP, (item) => ({
  ...item,
  label: item.name,
  value: item.id,
}));
